import { useEnv } from "./use-env";
import { useSite } from "./use-site";
import { useSiteMetadata } from "./use-site-metadata";
export var useSiteOwnerName = function () {
  var metadata = useSiteMetadata();
  var site = useSite();
  var env = useEnv();
  return site.ownerName || metadata.ownerName || env.ORG_NAME || '';
};